var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M20 17.563l-7.653-7.579 7.576-7.645L17.563 0 9.988 7.65 2.342.075 0 2.417l7.655 7.588-7.58 7.653L2.418 20l7.594-7.66 7.65 7.583z","opacity":".615"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Close;

Close.default = Close;



// WEBPACK FOOTER //
// ./src/Assets/Icons/close.svg